/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, func } from 'prop-types';
import {
    Card, CardContent, Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { commonUseStyles } from '../../../../../style/commonStyles';
import { formatNameToProperCapitalization, relationshipMapping } from '../../../../AddressBook/RecipientBook/Common/Helpers/Helpers';
import RecipientAvatar from '../../../../AddressBook/RecipientBook/Common/Avatar/RecipientAvatar';

const useStyles = makeStyles(({ palette }) => ({
    card: {
        margin: '15px 0',
        padding: '10px',
        cursor: 'pointer',
    },
    cardContent: {
        padding: '10px 15px !important',
    },
    fullname: {
        fontWeight: '700',
        lineHeight: '1.6',
        fontSize: '16px',
        marginBottom: '5px',
    },
    recipientInfoContainer: {
        alignItems: 'center',
        marginBottom: '8px',
    },
    relationship: {
        fontSize: '14px',
        color: palette.text.secondary,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '200px',
    },
    avatarContainer: {
        display: 'flex',
        alignItems: 'center',
    },
}));

const RecepientCard = ({ recipient, setIsRecipientListVisible, setOtherOption, handleOptionChange }) => {
    const classes = useStyles();
    const customClasses = commonUseStyles();
    const recipientRelationship = relationshipMapping[recipient?.relationship];

    const getRecipNameOrCompanyName = () => {
        if (!(recipient.rcpFirstName && recipient.rcpLastName) && recipient.rcpEmployerName) {
            return formatNameToProperCapitalization(recipient.rcpEmployerName);
        }
        return formatNameToProperCapitalization(`${recipient.rcpFirstName} ${recipient.rcpLastName}`);
    };

    const handleSelection = () => {
        setIsRecipientListVisible(false);
        const nameWithRelationship = recipient?.rcpFirstName
            ? `${recipientRelationship} ${recipient.rcpFirstName} `
            : recipientRelationship;
        setOtherOption(nameWithRelationship);
        handleOptionChange(nameWithRelationship);
    };

    return (
        <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
                <Grid container onClick={handleSelection} className={classes.recipientInfoContainer} spacing={1}>
                    <Grid item lg={1} md={1} sm={2} xs={3} className={classes.avatarContainer}>
                        <RecipientAvatar
                            firstName={recipient?.rcpFirstName || recipient.rcpEmployerName}
                            lastName={recipient?.rcpLastName}
                            brandId='18B'
                        />
                    </Grid>
                    <Grid item lg={6} md={5} sm={6} xs={6}>
                        <p className={classes.fullname}>{getRecipNameOrCompanyName()}</p>
                    </Grid>
                    <Grid item lg={5} md={3} sm={4} xs={3}>
                        <p className={customClasses.gridRecipient}>{recipientRelationship}</p>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
RecepientCard.propTypes = {
    recipient: object.isRequired,
    setIsRecipientListVisible: func,
    setOtherOption: func,
    handleOptionChange: func.isRequired,
};
export default RecepientCard;
